<app-uni-page  [parent]="this" pageTitle="Back Orders for Manufacturer: {{ getTitle() }}"
  [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  
    <app-ag-grid [gridOptions]="pombGridOptions" [rowData]="pombItems" ></app-ag-grid>
  
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <!-- Anonymous access: Show Close button -->
    <button *ngIf="isAnonymousAccess && !this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-times" (click)="closeWindow()">
      <span>Close</span>
    </button>
    <!-- Authenticated access: Show Go Back button -->
    <button *ngIf="!isAnonymousAccess && !this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-check" (click)="saveChanges()">
      <span>Save</span>
    </button>
    <button *ngIf="this.uow.hasChanges()" pButton type="button" class="p-button-raised" icon="pi pi-undo" (click)="cancelChanges()">
      <span>Undo</span>
    </button>
  </div>
</ng-template>